export default function animateScroll() {
    const service = parseUrl('service')
    if (service) {
        jQuery('body, html').animate({
            scrollTop: jQuery(`.services-grid-item.${service}`).offset().top - 150,
        }, 1000)
    }
}
function parseUrl(name) {
    const param = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search)
    return param && param.length ? decodeURIComponent(param[1]) : ''
}